import { Injectable } from '@angular/core';

interface ClinicalObservationsLocalStorageData {
  pinnedGroups: string[];
}

@Injectable({
  providedIn: 'root',
})
export class ClinicalObservationsLocalStorageService {
  private lsKey = 'clinical-obs-preferences';

  togglePinnedGroup(groupType: string) {
    const pinnedGroups = this.getPinnedGroups();
    const newPinnedGroups = pinnedGroups.includes(groupType)
      ? pinnedGroups.filter((g) => g !== groupType)
      : [...pinnedGroups, groupType];
    localStorage.setItem(this.lsKey, JSON.stringify({ pinnedGroups: newPinnedGroups }));
  }

  getPinnedGroups() {
    const lsData = localStorage.getItem(this.lsKey);
    return lsData ? (JSON.parse(lsData) as ClinicalObservationsLocalStorageData).pinnedGroups : [];
  }
}
